import { ChipColor } from 'src/shared/design-system/Chip';
import styled from 'styled-components';
import { Spacing } from 'web-common/src/shared/styles';
import { ConsumerOrderShefChip } from './ConsumerOrderShefChip';
import { RatingChip } from './RatingChip';

const MAX_TAGS_TO_RENDER = 3;

const ChipsContainer = styled.div`
  display: flex;
  gap: ${Spacing.QUARTER};
  flex-wrap: wrap;
`;

const RATING_PERCENT_TO_TAG_COLOR: Record<100 | 0, ChipColor> = {
  100: ChipColor.LIGHT_LIGHT_YELLOW,
  0: ChipColor.LIGHT_LIGHT_RED,
};

export const CarouselLineItemChips = ({
  ratingPercent,
  tags,
}: {
  ratingPercent: 100 | 0;
  tags: string[];
}): JSX.Element => {
  const tagsToRender = tags.slice(0, MAX_TAGS_TO_RENDER);
  const numAdditionalTags = tags.length - tagsToRender.length;

  return (
    <ChipsContainer>
      <RatingChip ratingPercent={ratingPercent} />
      {tagsToRender.map((tag) => (
        <ConsumerOrderShefChip color={RATING_PERCENT_TO_TAG_COLOR[ratingPercent]} text={tag} key={tag} />
      ))}

      {numAdditionalTags > 0 ? (
        <ConsumerOrderShefChip color={RATING_PERCENT_TO_TAG_COLOR[ratingPercent]} text={`+${numAdditionalTags}`} />
      ) : null}
    </ChipsContainer>
  );
};
